import * as React from 'react';
import { clsx } from 'clsx';
const getWidth = (index, props) => {
    const { width, rows = 2 } = props;
    if (Array.isArray(width)) {
        return width[index];
    }
    // last paragraph
    if (rows - 1 === index) {
        return width;
    }
    return undefined;
};
const Paragraph = (props) => {
    const { prefixCls, className, style, rows = 0 } = props;
    const rowList = Array.from({ length: rows }).map((_, index) => (React.createElement("li", { key: index, style: { width: getWidth(index, props) } })));
    return (React.createElement("ul", { className: clsx(prefixCls, className), style: style }, rowList));
};
export default Paragraph;
